<template>
  <div class="flex w-full justify-start">
    <v-form ref="form" lazy-validation v-model="valid">
      <div class="flex items-center w-full m-1">
        <div
          class="flex bg-white items-center px-2 h-10 rounded-lg text-xs mx-2"
        >
          {{ $t("reports.filters.from") }}
          <DatePicker
            format="yyyy-MM-dd HH:mm"
            position="center"
            auto-apply
            :close-on-auto-apply="false"
            v-model="frDate"
            :rules="dateRule.concat(startDateRule)"
            :max-date="maxFromDate || toDate"
            placeholder="from"
            text-input
            required
            :clearable="false"
          >
          </DatePicker>
        </div>
        <div
          class="flex bg-white items-center px-2 h-10 rounded-lg text-xs mx-2"
        >
          {{ $t("reports.filters.to") }}
          <DatePicker
            v-model="toDate"
            auto-apply
            :close-on-auto-apply="false"
            :rules="dateRule.concat(endDateRule)"
            format="yyyy-MM-dd HH:mm"
            :min-date="minToDate || frDate"
            placeholder="to"
            text-input
            required
            :clearable="false"
          ></DatePicker>
        </div>
        <v-col cols="2" class="text-grey-darken-1" v-if="filterDuration">
          {{ $t("reports.filters.duration") }}
          <DatePicker
            dark
            enable-seconds
            v-model="duration"
            time-picker
            auto-apply
            :start-time="durationStart"
            :close-on-auto-apply="false"
            :placeholder="$t('reports.filters.duration_placeholder')"
            text-input
          >
            <template #input-icon>
              <v-icon class="input-slot-image ml-2">mdi-timelapse</v-icon>
            </template>
          </DatePicker></v-col
        >
        <div
          :class="[
            'relative inline-flex items-center bg-white border h-10 cursor-pointer rounded-lg p-2 text-sm mx-2',
          ]"
        >
          <p class="mr-2 text-xs text-gray-500">
            {{ $t("reports.filters.call_type") }}
          </p>
          <label for="options" class="mr-2">
            {{ selectedCallType }}
          </label>
          <v-icon class="text-gray-500 px-4">mdi-chevron-down</v-icon>

          <select
            v-model="selectedCallType"
            id="options"
            class="absolute inset-0 opacity-0 cursor-pointer w-full h-full"
          >
            <option v-for="(callType, i) in callTypes" :key="i">
              {{ callType }}
            </option>
          </select>
        </div>
        <v-col cols="2" class="mt-1" v-if="filterAgent">
          <v-autocomplete
            v-model="selectedAgent"
            bg-color="teal"
            :items="selectAgents.concat(agentsArr)"
            :label="$t('reports.filters.select_agent')"
            :menu-props="{
              maxHeight: 200,
              offsetY: true,
              offsetOverflow: true,
            }"
          ></v-autocomplete>
        </v-col>
        <v-col cols="2" class="mt-1" v-if="filterHungparty">
          <v-select
            v-model="selectedHaung"
            bg-color="teal"
            :items="selectHaung"
            :label="$t('reports.filters.hung_party')"
          ></v-select
        ></v-col>

        <FloatLabel
          v-if="filterNumber"
          class="bg-white w-fit px-2 h-10 rounded-lg text-xs mx-2 border-2 border-gray-300"
        >
          <label for="number">{{ $t("reports.filters.number") }}</label>
          <InputText class="bg-transparent" id="number" v-model="numberText" />
        </FloatLabel>

        <v-col cols="2" class="mt-1" v-if="filterSkills">
          <v-select
            v-model="selectedSkill"
            bg-color="teal"
            :items="skillsArr"
            :label="$t('reports.filters.select_skill')"
          ></v-select
        ></v-col>
        <v-col cols="2" class="mt-1" v-if="filterPeriods">
          <v-select
            v-model="selectedPeriod"
            bg-color="teal"
            :items="periods"
            :label="$t('reports.filters.select_period')"
          ></v-select
        ></v-col>
        <v-col cols="2" class="mt-1" v-if="filterAgentStatus">
          <v-select
            v-model="selectedAgentStatus"
            bg-color="teal"
            :items="agentStatusArr"
            :label="$t('reports.filters.select_status')"
          ></v-select
        ></v-col>
        <v-col cols="2" class="mt-1" v-if="filterOmni">
          <v-select
            v-model="selectedOmniType"
            class="text-center"
            bg-color="teal"
            label="Select Omni"
            :items="omniTypes"
            :item-props="omniItemProps"
          >
            <template #selection="{ item }">
              <div v-if="item.value == 0" class="d-flex justify-center">
                {{ $t("reports.filters.all") }}
              </div>
              <v-icon v-else>
                {{ getMediaIcon(item.value) }}
              </v-icon>
            </template>
            <!-- <template #item="{ item }">
              <v-icon>{{ getMediaIcon(item.value) }}</v-icon>
            </template> -->
            <!-- <template v-slot:selection="{ item }">
              <v-icon>{{ getMediaIcon(item) }}</v-icon>
              {{ item == 0 ? $t("reports.filters.all") : "" }}
            </template>
            <template v-slot:item="{ item }">
              <v-icon>{{ getMediaIcon(item) }}</v-icon>
              {{ item == 0 ? $t("reports.filters.all") : "" }}
            </template> -->
          </v-select>
        </v-col>
        <v-spacer></v-spacer>
      </div>
    </v-form>
    <div class="flex items-center gap-4">
      <Button
        class="bg-primary-900 text-white h-10 py-2 px-4 rounded-lg text-xs"
        :disabled="loading"
        @click="submit"
        :loading="loading"
        :label="$t('reports.filters.get')"
      >
      </Button>
      <Button
        v-if="!NoExport"
        class="bg-orange-red text-white h-10 py-2 px-4 rounded-lg text-xs"
        :disabled="loadingExport"
        :loading="loadingExport"
        @click="submit(_, true)"
      >
        <v-icon class="text-white" v-if="enableBtns"
          >mdi-file-document-outline</v-icon
        >
        {{ $t("reports.filters.export") }}
      </Button>
    </div>
  </div>
</template>

<script>
//import AppDatePicker from "@/components/TheAppDatePicker.vue";
import moment from "moment";
import { Button, InputText, FloatLabel } from "primevue";

export default {
  name: "report-fiters-form",
  components: {
    Button,
    InputText,
    FloatLabel,
  },
  props: [
    "showCallType",
    "showAgent",
    "showHungparty",
    "showNumber",
    "showDuration",
    "showSkill",
    "showPeriods",
    "showAgentStatus",
    "hideExport",
    "showOmni",
    "agents",
    "skills",
  ],
  emits: ["submitReport"],
  data() {
    return {
      date: null,
      valid: true,
      textFieldProps: { appendIcon: "mdi-calendar" },
      frDate: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
      toDate: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss").toString(),
      callTypes: [
        this.$t("reports.filters.all"),
        this.$t("reports.filters.incoming"),
        this.$t("reports.filters.outgoing"),
      ],
      selectedCallType: this.$t("reports.filters.all"),
      selectAgents: [this.$t("reports.filters.all")],
      selectedAgent: this.$t("reports.filters.all"),
      selectHaung: [
        this.$t("reports.filters.all"),
        this.$t("reports.filters.agent"),
        this.$t("reports.filters.caller"),
      ],
      selectedHaung: this.$t("reports.filters.all"),
      numberText: "",
      duration: "",
      durationStart: { hours: 0, minutes: 0, seconds: 0 },
      periods: [
        this.$t("reports.filters.hours"),
        this.$t("reports.filters.days"),
      ],
      selectedSkill: "",
      selectedPeriod: this.$t("reports.filters.hours"),
      agentStatusArr: [
        this.$t("reports.filters.all"),
        this.$t("reports.filters.active"),
      ],
      selectedAgentStatus: this.$t("reports.filters.all"),
      selectedOmniType: 0,
      omniTypes: [0, 2, 3, 4, 5, 6, 7],
      dateRule: [
        (v) =>
          (!!v && moment(v, "YYYY-MM-DD HH:mm:ss", true).isValid()) ||
          this.$t("reports.filters.invalid_date"),
        (v) => !!v || this.$t("reports.filters.date_missing"),
      ],
      loading: false,
      loadingExport: false,
    };
  },
  methods: {
    async submit(_, isExport) {
      this.loading = !isExport;
      this.loadingExport = isExport;

      // console.log("My from filters", isExport);
      // console.log(
      //   "My frdate to send ",
      //   this.frDate,
      //   moment(this.frDate, "YYYY-MM-DD HH:mm:ss", true).format(
      //     "YYYY-MM-DD HH:mm:ss"
      //   )
      // );
      // console.log("Call List: " + this.callTypes.indexOf(this.selectedCallType));
      var filters = {
        from: moment(this.frDate, "YYYY-MM-DD HH:mm:ss", true).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        to: moment(this.toDate, "YYYY-MM-DD HH:mm:ss", true).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        callType: this.filterCallType
          ? this.callTypes.indexOf(this.selectedCallType)
          : null,
        agent: this.filterAgent
          ? this.selectedAgent == this.$t("reports.filters.all")
            ? "0"
            : this.selectedAgent
          : null,
        hungparty: this.filterHungparty
          ? this.selectHaung.indexOf(this.selectedHaung)
          : null,
        number: this.filterNumber ? this.numberText : null,
        duration:
          this.filterDuration && this.duration != ""
            ? moment(this.duration).format("HH:mm:ss")
            : "",
        skill: this.filterSkills ? this.selectedSkill : null,
        period: this.filterPeriods
          ? this.periods.indexOf(this.selectedPeriod) + 1
          : null,
        agentStatus: this.filterAgentStatus
          ? this.agentStatusArr.indexOf(this.selectedAgentStatus)
          : null,
        omniType: this.filterOmni ? this.selectedOmniType : null,
        export: isExport,
      };
      this.$emit("submitReport", filters);
      this.loading = false;
      this.loadingExport = false;
    },
    // getCallType(type) {
    //   if (type === "incoming") {
    //     return "1";
    //   } else if (type === "outgoing") {
    //     return "2";
    //   }
    // },

    getMediaIcon(type) {
      let icon;
      switch (type) {
        case 0:
          icon = "mdi-check-all";
          break;
        case 1:
          icon = "mdi-message";
          break;
        case 2:
          icon = "mdi-email";
          break;
        case 3:
          icon = "mdi-whatsapp";
          break;
        case 4:
          icon = "mdi-send-circle";
          break;
        case 5:
          icon = "mdi-facebook";
          break;
        case 6:
          icon = "mdi-instagram";
          break;
        case 7:
          icon = "mdi-twitter";
          break;
        default:
          icon = "mdi-message";
      }
      return icon;
    },
    omniItemProps(item) {
      return {
        title: item == 0 ? this.$t("reports.filters.all") : "",
        value: item,
        prependIcon: item != 0 ? this.getMediaIcon(item) : "",
      };
    },
  },
  computed: {
    endDateRule() {
      return [
        () =>
          moment(this.toDate).isAfter(this.frDate) ||
          this.$t("reports.filters.end_bigger_than_start"),
        () => {
          if (!this.frDate || !this.toDate) return true;
          const fromYear = moment(this.frDate).year();
          const toYear = moment(this.toDate).year();
          return fromYear === toYear || this.$t("reports.filters.same_year_required") || "Dates must be in the same year";
        }
      ];
    },
    startDateRule() {
      return [
        () =>
          moment(this.frDate).isBefore(this.toDate) ||
          this.$t("reports.filters.start_less_than_end"),
        () => {
          if (!this.frDate || !this.toDate) return true;
          const fromYear = moment(this.frDate).year();
          const toYear = moment(this.toDate).year();
          return fromYear === toYear || this.$t("reports.filters.same_year_required") || "Dates must be in the same year";
        }
      ];
    },
    // Max date for "from" picker: end of the year of "to" date
    maxFromDate() {
      if (!this.toDate) return null;
      return moment(this.toDate).endOf('year').format("YYYY-MM-DD HH:mm:ss");
    },
    // Min date for "to" picker: start of the year of "from" date
    minToDate() {
      if (!this.frDate) return null;
      const fromYearStart = moment(this.frDate).startOf('year').format("YYYY-MM-DD HH:mm:ss");
      // Also ensure it's not before frDate
      return this.frDate > fromYearStart ? this.frDate : fromYearStart;
    },
    enableBtns() {
      return (
        this.frDate != "" &&
        moment(this.frDate, "YYYY-MM-DD HH:mm:ss", true).isValid() &&
        this.toDate != "" &&
        moment(this.toDate, "YYYY-MM-DD HH:mm:ss", true).isValid()
      );
    },
    filterCallType() {
      return this.showCallType;
    },
    filterAgent() {
      return this.showAgent;
    },
    filterHungparty() {
      return this.showHungparty;
    },
    filterNumber() {
      return this.showNumber;
    },
    filterDuration() {
      return this.showDuration;
    },
    filterSkills() {
      return this.showSkill;
    },
    filterPeriods() {
      return this.showPeriods;
    },
    filterAgentStatus() {
      return this.showAgentStatus;
    },
    NoExport() {
      return this.hideExport;
    },
    filterOmni() {
      return this.showOmni;
    },
    agentsArr() {
      return this.agents ? this.agents : [];
    },
    skillsArr() {
      return this.skills ? this.skills : [];
    },
    // omniTypes() {
    //   return [
    //     { val: "All", icon: this.getMediaIcon(0) },
    //     { val: 2, icon: this.getMediaIcon(2) },
    //     { val: 3, icon: this.getMediaIcon(3) },
    //     // {
    //     //   title: this.$t("reports.filters.all"),
    //     //   props: { value: 0 },
    //     // },
    //     // {
    //     //   props: { value: 2, "prepend-icon": this.getMediaIcon(2) },
    //     // },
    //     // {
    //     //   props: { value: 3, "prepend-icon": this.getMediaIcon(3) },
    //     // },
    //   ];
    // },
    enableSubmit() {
      var yearCond = moment(this.frDate).year() === moment(this.toDate).year();
      var datesCond = moment(this.frDate).isBefore(this.toDate);
      if (!yearCond || !datesCond) {
        return false;
      }
      return true;
    },
  },
  watch: {
    skills(newValue) {
      // console.log("My skilll value watch", newValue);
      if (newValue) {
        this.selectedSkill = this.skills[0];
      }
    },
  },
};
</script>
<style>
.dp__input_wrap {
  width: 12 !important;
}
.v-field__input {
  padding-inline-start: 8px !important;
}
.v-field {
  --v-field-padding-start: 8px !important;
}
.dp__theme_light {
  --dp-background-color: #fff;
  --dp-text-color: #212121;
  --dp-hover-color: #f3f3f3;
  --dp-hover-text-color: #212121;
  --dp-hover-icon-color: #959595;
  --dp-primary-color: var(--p-primary-500) !important;
  --dp-border-color: white !important;
  --dp-menu-border-color: white !important;
  --dp-border-color-hover: white !important;
  --dp-border-color-focus: white !important;
  --dp-disabled-color: #f6f6f6;
}
::placeholder {
  color: black;
  opacity: 1; /* Firefox */
  padding-left: 6px;
}

::-ms-input-placeholder {
  /* Edge 12 -18 */
  color: black;
}
.dp__instance_calendar {
  background: white;
}
</style>
